<template>
  <div class="uk-grid " uk-grid>
    <div class="uk-width-1-3@s">
      <input :class="['uk-input', {'uk-form-danger': nameMissing}]" type="text" v-model="name" v-bind:placeholder="$t('setup.configuration.birdName')">
    </div>
    <div class="uk-width-1-3@s">
      <input :class="['uk-input', {'uk-form-danger': soundInvalid}]" type="text" v-model.lazy="filename" v-bind:placeholder="$t('setup.configuration.soundURL')">
    </div>
    <div class="uk-width-1-3@s">
      <button @click="add" class="uk-button uk-button-secondary" :disabled="valid ? false : true">{{ $t("setup.configuration.ready")}}</button>
      <span v-if="validated">
        <span v-if="!valid" class="messages" @click="alert">❗</span>
      </span>
    </div>
  </div>
</template>

<script>
  import ConfigurationEntry from "./ConfigurationEntry.vue"
  export default {
    data() {
      return {
        name: null,
        filename: null,
        loadingPassed: null,
        validated: false,
        error: null
      }
    },
    methods: {
      add() {
        this.validated = true;
        if (this.valid) {
          this.$emit("birdAdded", {index: String(this.index), name: this.name, filename: this.filename});
          this.name = null;
          this.filename = null;
          this.validated = false;
          this.loadingPassed = null;
        }
      },
      alert() {
        alert(this.error)
      }
    },
    computed: {
      valid() {
        return (this.validated && !!this.name && !this.soundInvalid)
      },
      nameMissing() {
        return this.validated && !this.name;
      },
      soundInvalid() {
        return this.soundMissing || this.pathWrong || this.soundFailed
      },
      soundFailed() {
        if (this.loadingPassed === false) {
          this.error = this.$t("setup.configuration.errors.notLoaded", {path: this.filename})
          return true
        }
      },
      soundMissing() {
        if (this.validated && !this.filename) {
          this.error = this.$t("setup.configuration.errors.empty")
          return true
        }
      },
      pathWrong() {
        if (this.filename && (this.filename.length < 5 || !["mp3", "wav"].includes(this.filename.substr(this.filename.length - 3)))) {
          this.validated = true
          this.error = this.$t("setup.configuration.errors.wrong")
          return true
        }
      }
    },
    watch: {
      filename: function(path) {
        if (this.filename && !this.pathWrong) {
          this.error = null
          this.loadingPassed = null
          this.validated = true
          let vm = this
          let sound = new Howl({src: [path], html5: true})
          sound.on("loaderror", function() {
            vm.loadingPassed = false
          })
          sound.on("load", function() {
            vm.loadingPassed = true
          })
        }
      }
    }
  }
</script>
<style scoped>
  .messages { cursor: pointer; }
</style>



// WEBPACK FOOTER //
// src/components/ConfigurationEntry.vue